const UsersRoutes = {
  getAllUsers: "/user",
  updateUserStatus: "/user/status",
  deleteUser: "/user/delete",
  getDeletedUsers: "/user/deleted",
}

export default UsersRoutes